import { event } from 'vue-gtag';

import { Registration } from '@/services/requests/onboarding/Onboarding.types';

export enum AnalyticsEvent {
  CHOOSE_USER_TYPE = 'choose_user_type',
  EMAIL_CONFIRM = 'signup_email_confirm',
  PHONE_CONFIRM = 'signup_phone_confirm',

  COMPANY_DETAILS_CONFIRM = 'details_confirm',
  ACCOUNT_MANAGER_CONFIRM = 'account_manager_confirm',
  DIRECTOR_AND_SHAREHOLDER_CONFIRM = 'directors_shareholders_confirm',
  CORPDOCS_UPLOAD = 'corpdocs_upload',

  PERSONAL_DATA_CONFIRM = 'personal_data_confirm',
  POI_CONFIRM = 'poi_confirm',
  POA_CONFIRM = 'poa_confirm',

  LIVENESS_CONFIRM = 'liveness_confirm',
  PRICING_CONFIRM = 'pricing_confirm',
}
interface EventPayload {
  user_type: Registration.Type;
  country_code?: string;
}
export function sendGAEvent(
  eventName: AnalyticsEvent.PHONE_CONFIRM,
  payload: { user_type: Registration.Type; country_code: string | undefined }
): void;

export function sendGAEvent(
  eventName: Exclude<AnalyticsEvent, AnalyticsEvent.PHONE_CONFIRM>,
  payload: { user_type: Registration.Type }
): void;

export function sendGAEvent(eventName: AnalyticsEvent, payload: EventPayload) {
  event(eventName, payload);
}
